import {getUserAuth} from 'common/src/modules/auth/auth.service';
import axios, {AxiosError, AxiosResponse} from 'axios';
import {ApiError} from '../errorHandling/errorHandling.types';
import constructApiService from './apiConstruct';
import {ApiOptions, ApiResponseV2} from './apiTypes';
import getApiBasePath from './utils/getApiBasePath';

function handleResponse<T>(response: AxiosResponse<T>) {
  return response.data;
}

function handleError(error: AxiosError<ApiResponseV2<unknown>>) {
  return {
    ...error,
    status: error.response?.status,
    message: error.response?.data?.message || error.message,
    isCanceled: axios.isCancel(error),
  } as ApiError;
}

function createApiUrl({endpoint, options}: {endpoint: string; options: ApiOptions}) {
  let v2Endpoint = `v2/${endpoint}`;
  const includeClientId = options.includeClientId ?? true;

  if (includeClientId) {
    const {clientId} = getUserAuth();

    v2Endpoint = `v2/${clientId}/${endpoint}`;
  }

  return new URL(v2Endpoint, getApiBasePath()).toString();
}

const apiV2Service = constructApiService({
  handleResponse,
  createApiUrl,
  handleError,
});

export default apiV2Service;
